import createReactComponent from '../createReactComponent';
var Code2 = createReactComponent('Code2', [['path', {
  d: 'M18 16L22 12L18 8',
  key: '1ag9f5'
}], ['path', {
  d: 'M6 8L2 12L6 16',
  key: 'kyvwex'
}], ['path', {
  d: 'M14.5 4L9.5 20',
  key: 'rtvdkh'
}]]);
export default Code2;